/* Del Mesa Liquor — Gift Options (in-house replacement for SC Product Options)
   The product form renders a server-side "MAKE IT A GIFT!" block (snippets/product-form.liquid)
   with Gift Wrap / Greeting Card checkboxes. When a submit happens with at least one box
   checked, this script takes over the submit in the capture phase (before the theme's own
   AjaxProduct handler), adds the main variant plus each checked add-on variant in ONE
   /cart/add.js call (add-on quantity = main quantity — the per-unit options model the old
   app used), then dispatches the theme's own 'ajaxProduct:added' event so the cart drawer
   refreshes and opens exactly as it does for a native add.
   When nothing is checked the submit is left completely untouched (native theme flow).
   Add-ons are the store's existing hidden products:
     Gift Wrap     variant 40661793996843 ($9.99)
     Greeting Card variant 39298361786411 ($6.99)
*/
(function () {
  'use strict';

  var inFlight = false;

  /* The card-message box is revealed only while GREETING CARD is checked.
     The typed text rides to the order as a line-item property on the
     Greeting Card line (properties: { Message: "..." }). Laurence's rule
     (2026-10-17): the message is REQUIRED whenever the card is checked —
     an empty or whitespace-only message blocks the add entirely (no
     /cart/add.js call, no native submit), shows the inline prompt next to
     the message box, and moves focus to the textarea. The prompt clears
     as soon as the customer types. Card unchecked = no requirement. */
  function syncMessageVisibility(block) {
    var card = block.querySelector('[data-dm-gift="card"]');
    var wrap = block.querySelector('[data-dm-gift-message-wrap]');
    if (card && wrap) wrap.hidden = !card.checked;
  }

  function setMessageError(block, show) {
    var err = block.querySelector('[data-dm-gift-message-error]');
    var msgEl = block.querySelector('[data-dm-gift-message]');
    if (err) err.hidden = !show;
    if (msgEl) msgEl.classList.toggle('dm-gift-options__textarea--error', !!show);
  }

  document.addEventListener('change', function (evt) {
    if (evt.target && evt.target.matches && evt.target.matches('[data-dm-gift="card"]')) {
      var block = evt.target.closest('[data-dm-gift-options]');
      if (block) {
        syncMessageVisibility(block);
        if (!evt.target.checked) setMessageError(block, false);
      }
    }
  });

  document.addEventListener('input', function (evt) {
    if (evt.target && evt.target.matches && evt.target.matches('[data-dm-gift-message]')) {
      var block = evt.target.closest('[data-dm-gift-options]');
      if (block && evt.target.value.trim()) setMessageError(block, false);
    }
  });

  function initBlocks() {
    document.querySelectorAll('[data-dm-gift-options]').forEach(syncMessageVisibility);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlocks);
  } else {
    initBlocks();
  }

  function getChecked(form) {
    var wrap = form.querySelector('[data-dm-gift="wrap"]');
    var card = form.querySelector('[data-dm-gift="card"]');
    return {
      wrap: !!(wrap && wrap.checked),
      card: !!(card && card.checked)
    };
  }

  function showError(form, message) {
    var old = form.querySelector('.errors');
    if (old) old.remove();
    var div = document.createElement('div');
    div.classList.add('errors', 'text-center');
    div.textContent = message;
    form.appendChild(div);
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.classList || !form.classList.contains('product-single__form')) return;

    var block = form.querySelector('[data-dm-gift-options]');
    if (!block) return;

    var checked = getChecked(form);
    if (!checked.wrap && !checked.card) return; // native theme flow, untouched

    // Take over before the theme's bubble-phase submit handler runs.
    evt.preventDefault();
    evt.stopPropagation();

    // Required-message gate: card checked but message empty/whitespace ->
    // block the add entirely (the submit is already prevented above, and no
    // /cart/add.js call is made), show the inline prompt, focus the box.
    var cardMsg = '';
    if (checked.card) {
      var msgEl0 = block.querySelector('[data-dm-gift-message]');
      cardMsg = msgEl0 ? msgEl0.value.trim() : '';
      if (!cardMsg) {
        setMessageError(block, true);
        if (msgEl0) msgEl0.focus();
        return;
      }
      setMessageError(block, false);
    }

    if (inFlight) return;
    inFlight = true;

    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('btn--loading');

    var fd = new FormData(form);
    var mainId = parseInt(fd.get('id'), 10);
    var qty = parseInt(fd.get('quantity'), 10);
    if (!mainId) { inFlight = false; if (btn) btn.classList.remove('btn--loading'); return; }
    if (isNaN(qty) || qty < 1) qty = 1;

    var properties = {};
    var hasProps = false;
    fd.forEach(function (value, key) {
      if (key.indexOf('properties[') === 0 && key.charAt(key.length - 1) === ']') {
        properties[key.slice(11, -1)] = value;
        hasProps = true;
      }
    });

    var mainItem = { id: mainId, quantity: qty };
    if (hasProps) mainItem.properties = properties;
    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan) mainItem.selling_plan = parseInt(sellingPlan, 10);

    var items = [mainItem];
    if (checked.wrap) items.push({ id: parseInt(block.getAttribute('data-wrap-variant'), 10), quantity: qty });
    if (checked.card) {
      var cardItem = { id: parseInt(block.getAttribute('data-card-variant'), 10), quantity: qty };
      if (cardMsg) cardItem.properties = { Message: cardMsg };
      items.push(cardItem);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        inFlight = false;
        if (btn) btn.classList.remove('btn--loading');

        if (!result.ok || (result.data && result.data.status === 422)) {
          var msg = (result.data && (result.data.description || result.data.message)) || 'Could not add to cart. Please try again.';
          showError(form, typeof msg === 'string' ? msg : 'Could not add to cart. Please try again.');
          return;
        }

        var addedItems = (result.data && result.data.items) || [];
        var mainAdded = addedItems.filter(function (i) { return i.id === mainId; })[0] || addedItems[0] || null;

        // Reproduce the theme's post-add behavior (drawer refresh + open, cart count).
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: mainAdded, addToCartBtn: btn },
          bubbles: true
        }));

        // Mirror the theme: adding from a product form on the cart page reloads.
        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          location.reload();
        }
      })
      .catch(function () {
        inFlight = false;
        if (btn) btn.classList.remove('btn--loading');
        showError(form, 'Could not add to cart. Please try again.');
      });
  }, true);
})();
